export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9700.0b9fda50.jpg";